import { _ as _sfc_main } from "./VaAvatar.vue_vue_type_script_lang-ea4f626b.mjs";
import { resolveComponent, openBlock, createElementBlock, normalizeClass, normalizeStyle, createBlock, renderSlot, normalizeProps, mergeProps, createVNode, createCommentVNode } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaAvatar_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = ["src", "alt"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_progress_circle = resolveComponent("va-progress-circle");
  const _component_va_fallback = resolveComponent("va-fallback");
  const _component_va_icon = resolveComponent("va-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["va-avatar", _ctx.classesComputed]),
    style: normalizeStyle(typeof _ctx.computedStyle === "object" ? Array.isArray(_ctx.computedStyle) ? [..._ctx.computedStyle, `--va-0-background-color-computed: ${String(_ctx.backgroundColorComputed)};--va-1-text-color-computed: ${String(_ctx.textColorComputed)};--va-2-size-computed: ${String(_ctx.sizeComputed)}`] : { ..._ctx.computedStyle, "--va-0-background-color-computed": String(_ctx.backgroundColorComputed), "--va-1-text-color-computed": String(_ctx.textColorComputed), "--va-2-size-computed": String(_ctx.sizeComputed) } : _ctx.computedStyle + `;--va-0-background-color-computed: ${String(_ctx.backgroundColorComputed)};--va-1-text-color-computed: ${String(_ctx.textColorComputed)};--va-2-size-computed: ${String(_ctx.sizeComputed)}`)
  }, [
    _ctx.$props.loading ? (openBlock(), createBlock(_component_va_progress_circle, {
      key: 0,
      size: _ctx.sizeComputed,
      color: _ctx.colorComputed,
      indeterminate: ""
    }, null, 8, ["size", "color"])) : renderSlot(_ctx.$slots, "default", normalizeProps(mergeProps({ key: 1 }, _ctx.avatarOptions)), () => [
      _ctx.$props.src && !_ctx.hasLoadError ? (openBlock(), createElementBlock("img", {
        key: 0,
        src: _ctx.$props.src,
        alt: _ctx.$props.alt,
        onError: _cache[0] || (_cache[0] = (...args) => _ctx.onLoadError && _ctx.onLoadError(...args))
      }, null, 40, _hoisted_1)) : _ctx.hasLoadError && _ctx.$props.src ? renderSlot(_ctx.$slots, "fallback", { key: 1 }, () => [
        createVNode(_component_va_fallback, mergeProps(_ctx.VaFallbackProps, {
          onFallback: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("fallback"))
        }), null, 16)
      ]) : _ctx.$props.icon ? (openBlock(), createBlock(_component_va_icon, {
        key: 2,
        name: _ctx.$props.icon
      }, null, 8, ["name"])) : createCommentVNode("", true)
    ])
  ], 6);
}
const _VaAvatar = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaAvatar as _
};
//# sourceMappingURL=VaAvatar-a4f51176.mjs.map
